import { formatFilterToObject, formatSortByToObject } from "../helpers";

const ENDPOINTS = {
  PRODUCT_INFO: '/product_info',
  SHIP_CITIES: '/ship_cities',
  INVENTORY_ATS_REPORT: '/available_to_sell',
  ADJUSTED_INVENTORY: '/adjusted_inventory',
  ADJUSTED_INVENTORY_COST: '/adjusted_inventory_cost_report',
  INVENTORY_LOCATIONS: '/inventory_locations',
  INVENTORY_QTYS: '/inventory_qtys',
  SALES_REPORT: '/sales_report',
  SALES_REPORT_SEARCH: '/sales_report_search',
};

export const INVENTORY_ATS_REPORT_DEFAULT_PARAMS = {
  itemsPerPage: 25,
  sortBy: formatSortByToObject('product_name', 'desc'),
  filter: formatFilterToObject(),
  page: 1,
  qty_includes_special:0
};

export default ENDPOINTS;
